<div class="error-message">
    @for (error of errors; track error) {
        {{ customMessage ? customMessage : error }}<br />
    }
</div>
<div class="full-text">
    @for (error of errors; track error) {
        <div>
            {{ customMessage ? customMessage : error }}
        </div>
    }
</div>
